import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'QueryTemplateSelectModal',
    props: {
        value: { type: Boolean },
        tableName: null
    },
    emits: ["input", "templateSelected"],
    setup(__props, { emit }) {
        const props = __props;
        const templates = computed(() => {
            return [
                {
                    name: 'Missing descriptions', value: [
                        {
                            name: 'Select rows with missing description',
                            code: `SELECT * FROM ${props.tableName} WHERE gdescription IS NOT NULL AND gdescription <> '';`,
                            useAI: 'forDescription',
                        }
                    ]
                },
            ];
        });
        function selectTemplate(item) {
            emit('templateSelected', item.value);
            //console.log(item.value);
            emit('input', false);
        }
        return { __sfc: true, props, emit, templates, selectTemplate };
    }
});
